import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeSlider from './HomeSlider';
import BookingForm from './BookingForm';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const [showBookingForm, setShowBookingForm] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  const openBookingForm = (e) => {
    e.preventDefault();
    setShowBookingForm(true);
  };

  return (
    <>
      <HomeSlider />

      <div className="about_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div 
                className="about_info"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="section_title mb-20px">
                  <span>About Us</span>
                  <h3>Luxury Apartment-Hotel and Hotel Villas</h3>
                </div>
                <p data-aos="fade-up" data-aos-delay="300">
                  The hotel extends over an area of 15,503 m², accessible via the northern scenic road. It is bordered by the golf course to the south, east, and west, offering breathtaking views of the Mediterranean Sea and the golf course.
                </p>
                <a 
                  href="/Apropos" 
                  onClick={(e) => { e.preventDefault(); handleNavigation('/Apropos'); }}  
                  className="line-button"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  See More
                </a>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7">
              <div className="about_thumb d-flex">
                <div 
                  className="img_1"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <img src="assets/img/about/about_1.png" alt="About hotel"/>
                </div>
                <div 
                  className="img_2"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                >
                  <img src="assets/img/about/about_2.png" alt="Hotel view"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offers_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div 
                className="section_title text-center mb-100"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <span>Our Offers</span>
                <h3>Current Offers</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div 
              className="col-xl-4 col-md-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="single_offers">
                <div className="about_thumb">
                  <img src="assets/img/offers/1.png" alt="Offer 1"/>
                </div>
                <h3>Up to 35% off on Club Rooms and Suites</h3>
                <ul>
                  <li>Luxury Amenities</li>
                  <li>Capacity: 3 adults and 2 children</li>
                  <li>Sea View</li>
                </ul>
                {/*<a href="#" className="book_now" onClick={openBookingForm}>
                  Book Now
                </a>*/}
                <a href="" className="book_now" >
                  Book Now
                </a>
              </div>
            </div>
            <div 
              className="col-xl-4 col-md-4"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="single_offers">
                <div className="about_thumb">
                  <img src="assets/img/offers/2.png" alt="Offer 2"/>
                </div>
                <h3>Up to 35% off on Club Rooms and Suites</h3>
                <ul>
                  <li>Luxury Amenities</li>
                  <li>Capacity: 3 adults and 2 children</li>
                  <li>Sea View</li>
                </ul>
                {/*<a href="#" className="book_now" onClick={openBookingForm}>
                  Book Now
                </a>*/}
                <a href="" className="book_now" >
                  Book Now
                </a>
              </div>
            </div>
            <div 
              className="col-xl-4 col-md-4"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="single_offers">
                <div className="about_thumb">
                  <img src="assets/img/offers/3.png" alt="Offer 3"/>
                </div>
                <h3>Up to 35% off on Club Rooms and Suites</h3>
                <ul>
                  <li>Luxury Amenities</li>
                  <li>Capacity: 3 adults and 2 children</li>
                  <li>Sea View</li>
                </ul>
                {/*<a href="#" className="book_now" onClick={openBookingForm}>
                  Book Now
                </a>*/}
                <a href="" className="book_now" >
                  Book Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="video_area video_bg overlay"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <div className="video_area_inner text-center">
          <span>Club Les Pins Sea View</span>
          <h3>Relax and enjoy your <br/>vacation </h3>
          <a href="https://www.youtube.com/watch?v=vLnPwxZdW4Y" className="video_btn popup-video">
            <i className="fa fa-play" style={{ color: '#717fe0' }}></i>
          </a>
        </div>
      </div>

      <div className="about_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-7">
              <div className="about_thumb2 d-flex">
                <div 
                  className="img_1"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <img src="assets/img/about/1.png" alt="Cuisine 1"/>
                </div>
                <div 
                  className="img_2"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                >
                  <img src="assets/img/about/2.png" alt="Cuisine 2"/>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div 
                className="about_info"
                data-aos="fade-left"
                data-aos-delay="400"
              >
                <div className="section_title mb-20px">
                  <span>Delicious Cuisine</span>
                  <h3>We serve fresh and flavorful dishes</h3>
                </div>
                <p>
                  Each plate is carefully prepared by our professional chefs using high-quality ingredients, blending authenticity and refinement. Discover unique flavors, a mix of tradition and creativity, for an unforgettable culinary experience.
                </p>
                <a href="" className="line-button">Learn More</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="features_room">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div 
                className="section_title text-center mb-100"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <span>Featured Rooms</span>
                <h3>Choose the Room That Suits You</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="rooms_here">
          <div 
            className="single_rooms"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="room_thumb">
              <img src="assets/img/rooms/1.png" alt="Superior Room"/>
              <div className="room_heading d-flex justify-content-between align-items-center">
                <div className="room_heading_inner">
                  <span>From 250 DT/night</span>
                  <h3>Superior Room</h3>
                </div>
                {/*<a href="#" className="line-button" onClick={openBookingForm}>Book Now</a>*/}
                <a href="" className="line-button" >Book Now</a>
              </div>
            </div>
          </div>
          <div 
            className="single_rooms"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="room_thumb">
              <img src="assets/img/rooms/2.png" alt="Deluxe Room"/>
              <div className="room_heading d-flex justify-content-between align-items-center">
                <div className="room_heading_inner">
                  <span>From 300 DT/night</span>
                  <h3>Deluxe Room</h3>
                </div>
                {/*<a href="#" className="line-button" onClick={openBookingForm}>Book Now</a>*/}
                <a href="" className="line-button" >Book Now</a>
              </div>
            </div>
          </div>
          <div 
            className="single_rooms"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div className="room_thumb">
              <img src="assets/img/rooms/3.png" alt="Signature Room"/>
              <div className="room_heading d-flex justify-content-between align-items-center">
                <div className="room_heading_inner">
                  <span>From 250 DT/night</span>
                  <h3>Signature Room</h3>
                </div>
               {/*} <a href="#" className="line-button" onClick={openBookingForm}>Book Now</a>*/}
                <a href="" className="line-button" >Book Now</a>
              </div>
            </div>
          </div>
          <div 
            className="single_rooms"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <div className="room_thumb">
              <img src="assets/img/rooms/4.png" alt="Couple Room"/>
              <div className="room_heading d-flex justify-content-between align-items-center">
                <div className="room_heading_inner">
                  <span>From 250 DT/night</span>
                  <h3>Couple Room</h3>
                </div>
                {/*<a href="#" className="line-button" onClick={openBookingForm}>Book Now</a>*/}
                <a href="" className="line-button" >Book Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="forQuery"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-md-12">
              <div className="Query_border">
                <div className="row align-items-center justify-content-center">
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-right"
                    data-aos-delay="300"
                  >
                    <div className="Query_text">
                      <p>For a Reservation or an Inquiry?</p>
                    </div>
                  </div>
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-left"
                    data-aos-delay="400"
                  >
                    <div className="phone_num">
                      <a href="/contact" onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} className="mobile_no">+216 98 370 055</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Instagram Area avec animations */}
      <div className="instragram_area">
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <img src="assets/img/instragram/1.png" alt="Instagram 1"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <img src="assets/img/instragram/2.png" alt="Instagram 2"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <img src="assets/img/instragram/3.png" alt="Instagram 3"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="500"
        >
          <img src="assets/img/instragram/4.png" alt="Instagram 4"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="600"
        >
          <img src="assets/img/instragram/5.png" alt="Instagram 5"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      {showBookingForm && (
        <BookingForm onClose={() => setShowBookingForm(false)} />
      )}
    </>
  );
};

export default Home;